var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: {
        name: _vm.disableAnimation ? null : "ui-alert--transition-toggle",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "ui-alert",
          class: _vm.classes,
          attrs: { role: "alert" },
        },
        [
          _c("div", { staticClass: "ui-alert__body" }, [
            !_vm.removeIcon
              ? _c(
                  "div",
                  { staticClass: "ui-alert__icon" },
                  [
                    _vm._t("icon", function () {
                      return [
                        _vm.type === "info"
                          ? _c("UiIcon", [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M12.984 9V6.984h-1.97V9h1.97zm0 8.016v-6h-1.97v6h1.97zm-.984-15c5.53 0 9.984 4.453 9.984 9.984S17.53 21.984 12 21.984 2.016 17.53 2.016 12 6.47 2.016 12 2.016z",
                                    },
                                  }),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm.type === "success"
                          ? _c("UiIcon", [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M9.984 17.016l9-9-1.406-1.453-7.594 7.594-3.563-3.563L5.016 12zm2.016-15c5.53 0 9.984 4.453 9.984 9.984S17.53 21.984 12 21.984 2.016 17.53 2.016 12 6.47 2.016 12 2.016z",
                                    },
                                  }),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm.type === "warning"
                          ? _c("UiIcon", [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M12.984 14.016v-4.03h-1.97v4.03h1.97zm0 3.984v-2.016h-1.97V18h1.97zm-12 3L12 2.016 23.016 21H.986z",
                                    },
                                  }),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm.type === "error"
                          ? _c("UiIcon", [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M12.984 12.984v-6h-1.97v6h1.97zm0 4.032V15h-1.97v2.016h1.97zm-.984-15c5.53 0 9.984 4.453 9.984 9.984S17.53 21.984 12 21.984 2.016 17.53 2.016 12 6.47 2.016 12 2.016z",
                                    },
                                  }),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]
                    }),
                  ],
                  2
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "ui-alert__content" },
              [_vm._t("default")],
              2
            ),
            _c(
              "div",
              { staticClass: "ui-alert__dismiss-button" },
              [
                _vm.dismissible
                  ? _c("UiCloseButton", {
                      attrs: { size: "small" },
                      on: { click: _vm.dismissAlert },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }